export default __webpack_public_path__ + "static/media/icon-puzzle.7e2376cc.svg";